module.exports = __webpack_public_path__ + "static/media/CashPickUp.5e8826da.svg";